<template>
  <div :style="circleStyle">
    <em v-if="!$slots.icon" :class="iconClass" :style="iconStyle" />
    <slot name="icon" />
  </div>
</template>

<script>
export default {
  name: 'CircleIcon',
  props: {
    size: {
      type: String,
      default: '50px',
    },
    iconSize: {
      type: String,
      default: '20px',
    },
    color: {
      type: String,
      default: '#000',
    },
    iconColor: {
      type: String,
      default: '#fff',
    },
    icon: {
      type: String,
      required: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    circleStyle() {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: this.size,
        height: this.size,
        borderRadius: '50%',
        backgroundColor: this.color,
        boxShadow: this.shadow ? '0px 3px 6px #00000029' : '',
      };
    },
    iconStyle() {
      return {
        color: this.iconColor,
        fontSize: this.iconSize,
      };
    },
    iconClass() {
      return `fa fa-${this.icon}`;
    },
  },
};
</script>
